var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4611 16.5345L13.0798 17.1532C13.1775 17.2509 13.3358 17.2509 13.4334 17.1532L18.1001 12.4866C18.3686 12.2181 18.3686 11.7828 18.1001 11.5143L13.4334 6.84764C13.3865 6.80075 13.3229 6.77441 13.2566 6.77441C13.1903 6.77441 13.1267 6.80075 13.0798 6.84764L12.4611 7.46636C12.3635 7.56399 12.3635 7.72228 12.4611 7.81991L15.9542 11.3129H5.94727C5.80919 11.3129 5.69727 11.4249 5.69727 11.5629V12.4379C5.69727 12.576 5.80919 12.6879 5.94727 12.6879H15.9542L12.4611 16.181C12.4142 16.2279 12.3879 16.2914 12.3879 16.3577C12.3879 16.4241 12.4142 16.4876 12.4611 16.5345Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a254b9b3b5eb9cae47534fe16e9bbcd2.svg";
export { ForwardRef as ReactComponent };